import { render, staticRenderFns } from "./checkItem.vue?vue&type=template&id=48b0147b"
import script from "./checkItem.vue?vue&type=script&lang=js"
export * from "./checkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports